import axios from '@/utils/request'
/**
 * 
 * @returns 专业类型（一级二级专业）
 */
export function getMajorTypeList() {
    return axios.get('/admin_api/v1/study_abroad/common/fir_sec_major/')
}
/**
 * 
 * @returns 院校国家，地区
 */
export function getSchoolCountryCity() {
    return axios.get('/admin_api/v1/study_abroad/school_country_city/')
}
/**
 * 
 * @returns 院校列表
 */
export function getSchoolList(params) {
    return axios.get('/admin_api/v1/study_abroad/school/',{params})
}
/**
 * 
 * @param {*} school_id 
 * @returns 院校详情
 */
export function getSchoolDetail(school_id) {
    return axios.get(`/admin_api/v1/study_abroad/school/${school_id}/`)
}
/**
 * 
 * @param {*} school_id 
 * @returns 院校详情---专业列表
 */
export function getMajorTableList(school_id,params) {
    return axios.get(`/admin_api/v1/study_abroad/school/${school_id}/school_major/`,{params})
}
/**
 *
 * @param {*} params
 * @returns 院校专业详情    
 */
export function getSchoolMajorList(params) {
    return axios.get('/admin_api/v1/study_abroad/school_major/',{params})
}

export function getSchoolMajorDetail(school_major_id) {
    return axios.get(`/admin_api/v1/study_abroad/school_major/${school_major_id}/`)
}
/**
 * 
 * @param {*} 
 * @returns 国家下拉
 */
export function getCountryDropdownList() {
    return axios.get(`/admin_api/v1/study_abroad/school_rank/dropdown_country/`)
}
/**
 * 
 * @returns 院校下拉
 */
export function getSchoolDropdownList() {
    return axios.get(`/admin_api/v1/study_abroad/school_rank/dropdown_school/`)
}
/**
 *
 * @returns 年份下拉
 */
export function getYearDropdownList() {
    return axios.get(`/admin_api/v1/study_abroad/school_rank/dropdown_year/`)
}
/**
 * 
 * @param {*} params 
 * @returns 排名列表
 */
export function getSchoolRank(params) {
    return axios.get(`/admin_api/v1/study_abroad/school_rank/`,{params})
}